export type {
  TransactionHistoryFromData,
  TransactionDetailFromData,
  TransactionHistoryInitializationData,
} from './session-storage'

export type {
  CompositionLoginUserInfo,
  PopusTakeOverTransactionInfo,
  CorporateOption,
} from './composition'

/** @description 受領状態 */
export enum ReceivedStatus {
  /** @description 値が存在しない */
  NO_VALUE = -1,
  /** @description 未受領 */
  NOT_YET = 1,
  /** @description 受領済 */
  ALREADY = 2,
  /** @description 受領拒否 */
  REJECTED = 3,
  /** @description 送信取消 */
  CANCEL_SEND = 4,
  /** @description 無料プラン */
  FREE_PLAN = 5,
}
